import { useMemo } from "react";
import ServiceTypeSection from "./TicketFormSteps/ServiceTypeSection";
import DetailsSection from "./TicketFormSteps/DetailsSection";
import ImageUploadSection from "./TicketFormSteps/ImageUploadSection";

/**
 * Hook that defines the form steps configuration
 * Each step can have validation logic and custom props
 */
export const useTicketFormSteps = ({
  serviceTypes,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  validateField,
  setFieldValue,
  onNext,
}) => {
  return useMemo(
    () => [
      {
        id: "service-type",
        label: "ticket.create.select_type",
        component: ServiceTypeSection,
        props: {
          serviceTypes,
          onNext,
          handleSetFieldValue: (field, value) =>
            setFieldValue(field, Number(value)),
        },
        // Step 1 has custom navigation (auto-advances on selection)
        showNavigation: false,
      },
      {
        id: "details",
        label: "ticket.create.detail.title",
        component: DetailsSection,
        props: {
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          validateField,
        },
        showNavigation: true,
      },
      {
        id: "images",
        label: "ticket.create.images.title",
        component: ImageUploadSection,
        props: {
          values,
          handleSetFieldValue: (field, value) => setFieldValue(field, value),
        },
        showNavigation: true,
      },
    ],
    [
      serviceTypes,
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      validateField,
      setFieldValue,
      onNext,
    ],
  );
};
